import { ComponentType, useCallback, useEffect, useRef } from 'react';

import { Modals } from '@/helpers/modals';

export const useDialogsPreloading = (modals: Modals[]) => {
  const cacheRef = useRef<Map<Modals, ComponentType>>(new Map());

  const preloadModals = useCallback((modals: Modals[]) => {
    const cache = cacheRef.current;

    const promises = modals
      .filter((modal) => !cache.has(modal))
      .map(async (modal) => {
        try {
          const file = await import(
            /* webpackChunkName: "dialog-[request]" */ `@/components/dialogs/${modal}`
          );
          const component = file.default;
          cache.set(modal, component);
        } catch (error) {
          console.error(`Failed to preload modal ${modal}:`, error);
        }
      });

    return Promise.all(promises);
  }, []);

  useEffect(() => {
    preloadModals(modals);
  }, [modals, preloadModals]);

  return cacheRef.current;
};
